import Box from '@mui/material/Box/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import { styled } from '@mui/material/styles'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import { TableContainer, Table, TableHead, TableRow, TableBody, Paper, Pagination, Grid, Button } from '@mui/material'
import { TIContextType, useTIContext } from '@pages/TradeinSales/context/sales.context'
import { CurrencyFormat } from '@utils/Currency.utility'
import { exportTableToExcel } from '@utils/Excel.utility'
import { ReactComponent as Excel } from '@assets/svg/excel.svg'

import moment from 'moment'
import React, { useEffect, useState } from 'react'

const ITEMS_PER_PAGE = 10

const TableTradeInSales = () => {
  const { tiCtx } = useTIContext() as TIContextType
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [currentData, setCurrentData] = useState<any[]>([])

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value)
  }

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14
    }
  }))

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0
    }
  }))

  const fetchTradeinData = () => {
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE
    const endIndex = startIndex + ITEMS_PER_PAGE
    const paginatedData = tiCtx.listTradein.slice(startIndex, endIndex)

    setTotalPages(Math.ceil(tiCtx.listTradein.length / ITEMS_PER_PAGE))
    setCurrentData(paginatedData)
  }

  useEffect(() => {
    fetchTradeinData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, tiCtx.listTradein])

  return (
    <Box my={2}>
      <Card>
        <CardContent>
          <Grid item xs={12} md={12} lg={3} xl={3}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'right',
                justifyContent: 'right',
                marginBottom: '10px'
              }}
            >
              <Button
                variant='contained'
                color='success'
                size='small'
                onClick={() =>
                  exportTableToExcel(
                    'idTableTradeinSalesAll',
                    'Ventas Trade-in'
                  )}
                disabled={currentData.length === 0}
              >
                <Excel className='me-2' /> Exportar
              </Button>
            </Box>
          </Grid>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label='customized table' id='idTableTradeinSales'>
              <TableHead>
                <TableRow>
                  <StyledTableCell align='left'>Estado</StyledTableCell>
                  <StyledTableCell align='left'>N° de Orden</StyledTableCell>
                  <StyledTableCell align='left'>Marca</StyledTableCell>
                  <StyledTableCell align='left'>Modelo</StyledTableCell>
                  <StyledTableCell align='left'>IMEI</StyledTableCell>
                  <StyledTableCell align='left'>Email</StyledTableCell>
                  <StyledTableCell align='left'>Total cancelado</StyledTableCell>
                  <StyledTableCell align='left'>Monto descuento</StyledTableCell>
                  <StyledTableCell align='left'>Código de descuento</StyledTableCell>
                  <StyledTableCell align='left'>Retirado</StyledTableCell>
                  <StyledTableCell align='left'>Fecha</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentData.map((row, i) => (
                  <StyledTableRow key={i}>
                    <StyledTableCell style={{ color: row.status === 1 ? 'green' : 'red' }} align='left'>
                      {row.status === 1 ? 'Válido' : 'Anulada'}
                    </StyledTableCell>
                    <StyledTableCell component='th' scope='row'>
                      #{row.id_order_platform}
                    </StyledTableCell>
                    <StyledTableCell align='left'>{row.brand}</StyledTableCell>
                    <StyledTableCell align='left'>{row.model}</StyledTableCell>
                    <StyledTableCell align='left'>{row.IMEI}</StyledTableCell>
                    <StyledTableCell align='left'>{row.email}</StyledTableCell>
                    <StyledTableCell align='left'>{CurrencyFormat(row.total)}</StyledTableCell>
                    <StyledTableCell align='left'>{CurrencyFormat(row.discount)}</StyledTableCell>
                    <StyledTableCell align='left'>{row.discount_code.toUpperCase()}</StyledTableCell>
                    <StyledTableCell align='left'>{row.picked_up !== 0 ? 'Si' : 'No'}</StyledTableCell>
                    <StyledTableCell align='left'>{moment(row.created_at.split('T')[0]).format('L')}</StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color='primary'
            size='large'
            className='mt-3'
          />
        </CardContent>
      </Card>
      <TableContainer component={Paper} style={{ display: 'none' }} id='idTableTradeinSalesAll'>
        <Table aria-label='hidden table'>
          <TableHead>
            <TableRow>
              <StyledTableCell align='left'>Estado</StyledTableCell>
              <StyledTableCell align='left'>N° de Orden</StyledTableCell>
              <StyledTableCell align='left'>Marca</StyledTableCell>
              <StyledTableCell align='left'>Modelo</StyledTableCell>
              <StyledTableCell align='left'>IMEI</StyledTableCell>
              <StyledTableCell align='left'>Email</StyledTableCell>
              <StyledTableCell align='left'>Total cancelado</StyledTableCell>
              <StyledTableCell align='left'>Monto descuento</StyledTableCell>
              <StyledTableCell align='left'>Código de descuento</StyledTableCell>
              <StyledTableCell align='left'>Retirado</StyledTableCell>
              <StyledTableCell align='left'>Fecha</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tiCtx.listTradein.map((row, i) => (
              <StyledTableRow key={i}>
                <StyledTableCell style={{ color: row.status === 1 ? 'green' : 'red' }} align='left'>
                  {row.status === 1 ? 'Válido' : 'Anulada'}
                </StyledTableCell>
                <StyledTableCell component='th' scope='row'>
                  #{row.id_order_platform}
                </StyledTableCell>
                <StyledTableCell align='left'>{row.brand}</StyledTableCell>
                <StyledTableCell align='left'>{row.model}</StyledTableCell>
                <StyledTableCell align='left'>{row.IMEI}</StyledTableCell>
                <StyledTableCell align='left'>{row.email}</StyledTableCell>
                <StyledTableCell align='left'>{CurrencyFormat(row.total)}</StyledTableCell>
                <StyledTableCell align='left'>{CurrencyFormat(row.discount)}</StyledTableCell>
                <StyledTableCell align='left'>{row.discount_code.toUpperCase()}</StyledTableCell>
                <StyledTableCell align='left'>{row.picked_up !== 0 ? 'Si' : 'No'}</StyledTableCell>
                <StyledTableCell align='left'>{moment(row.created_at.split('T')[0]).format('L')}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default TableTradeInSales
